module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Introduction"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Introduction ")])]), _c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("I wandered into my grandmother’s kitchen looking for her bright smile, knowing she would\n        have something wonderful for me to taste. ")]), _vm._v(" "), _c('p', [_vm._v("On this day, she had her back to me. She was round and soft and held her waist-long hair in\n        a braid that she wound like a doughnut at the nape of her neck. Now it was unruly, with\n        wisps of hair flying here and there, and as she turned to me I saw that her look was\n        triumphant and her cheeks were flushed. She was pulling a hot pot out of the oven and was\n        swinging it around heavily to land with a thud on the wooden kitchen table. Her pot was\n        bursting at the top with a golden crust that oozed bubbling brown gravy down the sides. Ever\n        since that pot had been brought to her as a gift from Europe, she had not gone a day without\n        using it. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of outdoor market."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of outdoor market.",
      "src": "images/IMG_2519.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of outdoor dining."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of outdoor dining.",
      "src": "images/IMG_3388.jpg"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Her coveted pot was an enameled cast iron Dutch oven. If she was the queen of her kitchen,\n        this pot was the queen of her cuisine. She would simmer a beef stew in it, and in the last\n        half hour of cooking, slice in whole sour dill pickles that picked up the scent of beef and\n        flavored the gravy. She would cook a holiday sauerbraten in it. She loved baking fruit in\n        sugar syrup and topping it with dumplings for dessert. She roasted her lamb, basted her\n        chicken, baked her cornbread, and even scrambled eggs in it for our breakfast. ")]), _vm._v(" "), _c('p', [_vm._v("I have it in my kitchen now. The insides are scarred and chipped and almost brown from\n        years of cooking. While I have given her pot a place of honor high on a shelf in my kitchen,\n        mine are all around me, as integral to my way of cooking as hers was for her. The circle has\n        come around. The only difference? I have lots of them. As the years have gone by, I have\n        acquired more and more of them, impervious to logic, rather reveling in discovering a new\n        one or new color or size or vintage piece to add to my collection. ")]), _vm._v(" "), _c('p', [_vm._v("I wish I could talk to my grandmother about it. Times have changed. In those days, she\n        cooked with her one heavy enameled Dutch oven and with her cast iron skillets. She would be\n        amazed that there are so many brands to choose from now, so many sizes, weights, colors, and\n        materials. She would also be fascinated to learn about where they come from and who makes\n        them, as I am. I had no idea that they are handcrafted and one of a kind. ")]), _vm._v(" "), _c('p', [_vm._v("What I did know was that the best are made in France, and those are the ones I collect. It\n        is a subjective and personal opinion based upon years of trying different ones. Mine are\n        French ovens and are 100 percent made in France. ")]), _vm._v(" "), _c('p', [_vm._v("So come join me on this journey to discover the French ovens of France, who creates them,\n        what makes them so special, and why they are the most valuable pot you can have in your\n        kitchen. I have developed recipes for them to show you how versatile they are and to\n        illustrate the many ways they can be used. Try them then come join me at the table. À table! ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of couple at table."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of couple at table.",
      "src": "images/IMG_0909.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of menu with flowers."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of menu with flowers.",
      "src": "images/IMG_9529.jpg"
    }
  })])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e99",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("A Brief History of Dutch Ovens ")])]), _c('a', {
    attrs: {
      "id": "d0e99",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("Cast iron pots molded in sand have been used for centuries and have evolved as different\n        technologies developed, as new manufacturers arrived on the scene, and as tastes changed. ")]), _vm._v(" "), _c('p', [_vm._v("The technology for making cast iron evolved in China centuries ago during the Iron Age. In\n        Europe, the use of cast iron first developed during the fifteenth century in order to make\n        cannons. It later grew to furnish cast iron pots for households for cooking purposes. ")]), _vm._v(" "), _c('p', [_vm._v("By the late 1700s the Dutch were experimenting with and perfecting a way to cast iron\n        cooking pots in dry sand in order to make them smooth. Many believe the term “Dutch oven”\n        comes from this kind of lidded pot originally made in Holland. The English liked them so\n        much they began to import them then eventually brought the manufacturing process back to\n        England to produce them for English households. ")]), _vm._v(" "), _c('p', [_vm._v("Cast iron cooking pots then migrated with English colonists to America and were\n        indispensable to settlers who pioneered on horseback and in wagons from the East coast to\n        the West coast. The pots had short legs so that the traveling settlers could nestle them\n        into wood-stoked campfires. ")]), _vm._v(" "), _c('p', [_vm._v("In the beginning of the twentieth century, cast iron pots and skillets became very popular\n        in America. Brands like Griswold and Wagner Ware were in demand. Lodge is the only American\n        brand remaining that still produces uncoated cast iron cookware in America at its plant in\n        South Pittsburg, Tennessee, which it has been doing since 1896. (Its enameled Dutch ovens,\n        however, are made in China). Today these kinds of ovens, with legs and lids that can hold\n        burning embers, are referred to as Dutch ovens, camping, chuck wagon, or cowboy Dutch ovens,\n        and are used by campers when cooking over wood fires or using charcoal outdoors. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of window box of flowers."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of window box of flowers.",
      "src": "images/IMG_8127.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of cafe sign."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of cafe sign.",
      "src": "images/IMG_7673.jpg"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("When we bring cast iron cooking pots indoors to be used on the kitchen stove or in the\n        oven, they are, more often than not, enameled versions, still referred to as “Dutch” ovens.\n        The process for enameling cast iron Dutch ovens—grinding down glass fragments, color\n        pigments, and minerals together until they are a fine powder that is sprayed onto cast iron\n        pots then fired at high temperatures until the glass melts to fuse with the cast iron and\n        turn into a glossy enamel coating—developed in the twentieth century. They are now made all\n        over the world with varying degrees of quality and price. ")]), _vm._v(" "), _c('p', [_vm._v("While we immediately think of heavy enameled cast iron pots when we hear the term Dutch\n        oven, the term refers to any cast iron, enameled cast iron, ceramic, clay, aluminum, clad,\n        or stainless steel pots that have wide bottoms and high sides with a lid that act like mini\n        ovens, capturing and evenly distributing heat. ")]), _vm._v(" "), _c('p', [_vm._v("I think the best are made in France. The reasons I prefer them is that they have the best\n        design and performance for my needs. With each passing year, French manufacturers have\n        poured more money into research and design in order to make their French ovens function at a\n        higher level, at higher heat, with less weight and increased ability to withstand chipping\n        compared to the relatively lower level of manufacturing standards from ovens made in other\n        countries, where quality control is more questionable. The biggest problem I have had with\n        non-French brands is in the quality of the coating, which tends to crack or chip over time,\n        resulting in the oven having to be replaced ")]), _vm._v(" "), _c('p', [_vm._v("And I have to admit, French ovens (known as "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("cocottes")])]), _vm._v(" in France) are hard for me to resist, as they are sublime to look at and handle,\n        each brand expressing its own look with flair. ")]), _vm._v(" "), _c('p', [_vm._v("So I think it is time to give credit where it is due and call Dutch ovens that are made in\n          France"), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v(" French ovens")])]), _vm._v(". Mine are French ovens, not Dutch ovens made anywhere else to any other standard. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of potatoes and onions."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of potatoes and onions.",
      "src": "images/IMG_0893.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of couple in front of fountain."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of couple in front of fountain.",
      "src": "images/IMG_3603.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "d0e99",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee45c18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch01.vue
// module id = 66
// module chunks = 0